module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/success_fa94e4.png";